import "../../../index73.css";
import { jsxs as H, jsx as D } from "react/jsx-runtime";
import { useRef as c, useCallback as f, useEffect as E } from "react";
import { a as l } from "../../../type-BFTbooL7.js";
import { _ as L } from "../../../cs-piwRuCFZ.js";
const M = "_th_cdv41_1", W = "_resize-handle_cdv41_8", v = {
  th: M,
  resizeHandle: W
};
function j(h) {
  const {
    className: p,
    children: w,
    onResize: o,
    onResizeComplete: d,
    name: s,
    ...R
  } = h, i = c(null), u = c(), n = c(), a = c(), t = f((e) => {
    var r;
    if (l(u.current) && i.current && o) {
      e.preventDefault(), e.stopPropagation();
      const _ = e.clientX - u.current;
      if (l(n.current)) {
        const m = n.current + _;
        a.current = m, o(m, s);
      } else
        n.current = (r = i.current) == null ? void 0 : r.offsetWidth;
    }
  }, [o, s]), z = f((e) => {
    var r;
    e.preventDefault(), u.current = e.clientX, n.current = (r = i.current) == null ? void 0 : r.offsetWidth, window.addEventListener("mousemove", t, !0);
  }, [t]);
  return E(() => {
    const e = () => {
      u.current = void 0, n.current = void 0, d && l(a.current) && d(a.current, s), window.removeEventListener("mousemove", t, !0);
    };
    return window.addEventListener("mouseup", e, !0), () => {
      window.removeEventListener("mouseup", e, !0), window.removeEventListener("mousemove", t, !0);
    };
  }, [t, s, d]), /* @__PURE__ */ H(
    "th",
    {
      ref: i,
      className: L(
        p,
        v.th
      ),
      ...R,
      children: [
        o && /* @__PURE__ */ D(
          "div",
          {
            role: "presentation",
            className: v.resizeHandle,
            onMouseDown: z
          }
        ),
        w
      ]
    }
  );
}
export {
  j as default
};
